/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { useState } from "react";
import * as yup from "yup";

const containerCSS = css`
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(28, 27, 88, 0.2);
    border-radius: 8px;
    border: 1px solid #d3d2fc;
    max-width: 342px;
    width: calc(100% - 16px * 2);

    @media (min-width: 556px) {
        max-width: 556px;
    }
`;
const inputCSS = css`
    appearance: none;
    background: #f6f6ff;
    border-radius: 1px;
    border: 1px solid #d3d2fc;
    color: #505050;
    font-family: inherit;
    font-size: 16px;
    height: 48px;
    line-height: 24px;
    margin-bottom: 12px;
    outline: 0;
    padding: 0 16px;
    width: 100%;

    @media (min-width: 556px) {
        font-size: 15px;
        margin-bottom: 0;
    }
`;
const btnCSS = css`
    appearance: none;
    border: 0;
    color: #ffffff;
    width: 100%;
    background: #504cf3;
    border-radius: 4px;
    width: 100%;
    padding: 0 16px;
    height: 48px;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: inherit;
    cursor: pointer;
`;
const headerCSS = css`
    border-radius: 8px 8px 0 0;
    height: 56px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    background: #f6f6ff;
    border-bottom: 1px solid #d3d2fc;

    i {
        color: #a7a5f9;
        font-size: 24px;
        margin-right: 12px;
    }

    span {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #504cf3;
    }

    @media (min-width: 556px) {
        height: 64px;
        padding: 0 24px;
    }
`;
const contentCSS = css`
    font-size: 14px;
    line-height: 24px;
    color: #505050;
    margin-bottom: 12px;

    @media (min-width: 556px) {
        font-size: 15px;
    }
`;
const bodyCSS = css`
    padding: 20px 16px;

    @media (min-width: 556px) {
        padding: 24px;
    }
`;
const fieldCSS = css`
    @media (min-width: 556px) {
        display: grid;
        grid-template-columns: 1fr 67px;
        column-gap: 12px;
    }
`;

const emailSchema = yup
    .string()
    .email()
    .required("Required");

function ItineraryEmailForm() {
    const [email, setEmail] = useState("");
    const onSubmit = async event => {
        event.preventDefault();
        const isValid = await emailSchema.isValid(email);
        if (!isValid) {
            return;
        }
        //TODO: send xhr email
    };

    return (
        <form css={containerCSS} onSubmit={onSubmit}>
            <div css={headerCSS}>
                <i className="trpr__icon-email"></i>
                <span>Email to myself</span>
            </div>
            <div css={bodyCSS}>
                <p css={contentCSS}>Send yourself a copy of this itinerary for safekeeping!</p>
                <div css={fieldCSS}>
                    <input
                        css={inputCSS}
                        type="email"
                        value={email}
                        onChange={event => setEmail(event.target.value)}
                        placeholder="Your email address"
                    />
                    <button css={btnCSS} type="submit">
                        Send
                    </button>
                </div>
            </div>
        </form>
    );
}

export default ItineraryEmailForm;
